import { Modal } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import Styles from "./PlaceBid.module.css";
import { Close, ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../../commons/Accordion";
import { useDispatch, useSelector } from "react-redux";
import ViewInjectionModal from "../ViewInjectionModal/ViewInjectionModal";
import { fetchInterestedListings } from "../../../../Redux/Slices/CapacitySlice";
import {
  formatDate,
  formatSlotTime,
  formatToDecimals,
} from "../../../../helpers/dateFormat";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";
import { getDamData } from "../../../../Services/BuySell/Listing";
import Marquee from "react-fast-marquee";
import DamStrip from "../Connection/DamStrip";

function ListingBox({ data, type }) {
  const [indentsModal, setIndentsModal] = useState(false);
  const list = useSelector((state) => state?.CapacitySlice?.list);
  const activeMain = useSelector(
    (state) => state?.persistedReducer?.user?.activeConsumerId,
  );
  const counterList = useSelector((state) => state?.CapacitySlice?.counterList);
  const activeListing = list?.find((ele) => ele?.id === activeMain);

  return (
    <>
      {indentsModal && type === "self" && (
        <ViewInjectionModal
          open={indentsModal}
          handleClose={() => setIndentsModal(false)}
          data={activeListing}
        />
      )}

      {indentsModal && type === "counter" && (
        <ViewInjectionModal
          open={indentsModal}
          handleClose={() => setIndentsModal(false)}
          data={counterList?.find((ele) => ele?.id === data.id)}
        />
      )}

      <div className={Styles.listingBox}>
        <div className={`display_flex_row ${Styles.selfListingHeader}`}>
          <div className={Styles.selfListingHeaderLeft}>
            <div>
              <div
                className={Styles.listingType}
                style={
                  type !== "self"
                    ? { color: "var(--primary-color-text)", fontWeight: 600 }
                    : {}
                }
              >
                {type === "self" ? "My Listing" : "Counterparty Listing"}
              </div>
              <div className={Styles.listingNumber}>{data?.name} </div>
            </div>
            <div>
              <div className={Styles.listingExpiry}>
                <div className={Styles.listingExpiryLabel}>
                  Listing Expires on
                </div>
                <span className={Styles.listingExpiryDetails}>
                  {formatDate(data?.listingExpDate)} - {data?.listingExpTime}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={Styles.detailsMainCont}>
          <div className={Styles.commonElem}>
            <div className={Styles.eachElemCom}>
              <div>Quantity</div>
              <div className={Styles.eachElemComValue}>
                {data.slots[0]?.purchaseEnergy || data.slots[0]?.sellEnergy}{" "}
                (MW)
              </div>
            </div>
            <div className={Styles.eachElemCom}>
              <div>Energy Rate</div>
              <div className={Styles.eachElemComValue}>
                {data?.slots?.[0]?.energyRateStr ||
                  data?.slots[0]?.landingCost ||
                  data?.slots[0]?.sellingCost}{" "}
                {data?.slots[0]?.energyRateType === "FIXED" && "(₹/kWh)"}
              </div>
            </div>
          </div>
          <div className={Styles.detailsContP2}>
            <div className={Styles.eachelemP2}>
              <div>Start & End Date</div>
              <div className={Styles.eachElemComValue}>
                {formatDate(data?.slots[0]?.dateStartAt)} -{" "}
                {formatDate(data?.slots[0]?.dateEndAt)}
              </div>
            </div>
            <div className={Styles.eachelemP2}>
              <div>Start & End Time</div>
              <div className={Styles.eachElemComValue}>
                {formatSlotTime(data?.slots[0]?.slotStartAt)} -{" "}
                {formatSlotTime(data?.slots[0]?.slotEndAt)}
              </div>
            </div>
          </div>
          {type !== "self" ? (
            <>
              {data?.slots?.length > 1 && (
                <div
                  type="button"
                  onClick={() => {
                    setIndentsModal(true);
                  }}
                  className={Styles.viewMoreElem}
                >
                  View All
                </div>
              )}
            </>
          ) : (
            <>
              {activeListing?.slots?.length > 1 && (
                <div
                  type="button"
                  onClick={() => {
                    setIndentsModal(true);
                  }}
                  className={Styles.viewMoreElem}
                >
                  View All
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

const PlaceBid = ({
  open,
  handleClose,
  connectionText,
  selfData,
  counterData,
  handleSubmit,
  loading,
}) => {
  const user = useSelector(
    (state) => state.persistedReducer.user?.activeRole,
  )?.toLowerCase();
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const handleAccordionChange = (index) => {
    setExpanded(expanded === index ? false : index);
  };
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const InterestedListings = useSelector(
    (state) => state.CapacitySlice?.interestedListings,
  );
  const interestedListingsLoading = useSelector(
    (state) => state.CapacitySlice?.fetchInterestedListingsLoading,
  );

  useEffect(() => {
    dispatch(fetchInterestedListings(counterData?.id));
  }, [counterData?.id, dispatch]);

  const handlePlaceBid = () => {
    let payload = {
      initiator: user,
      capacityConsumerId: user === "consumer" ? selfData?.id : counterData?.id,
      capacityGeneratorId:
        user === "generator" ? selfData?.id : counterData?.id,
      reason: "PRICE",
    };
    handleSubmit(payload);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.placeMainContainer}`}>
        <div className="modalHeading">
          <div>{connectionText}</div>
          <Close
            onClick={handleClose}
            style={{ cursor: "pointer" }}
            alterButton={false}
          />
        </div>

        <DamStrip />
        <div
          className={`display_flex_row_gap_8 ${Styles.placeReceivedContainer}`}
        >
          <div>
            <ListingBox data={selfData} type="self" />
          </div>
          <div>
            <ListingBox data={counterData} type="counter" />
          </div>
        </div>
        {InterestedListings && InterestedListings.length > 0 && (
          <div className={Styles.othersIntCompMain}>
            <Accordion
              expanded={expanded === "conn"}
              onChange={() => handleAccordionChange("conn")}
            >
              <AccordionSummary className={Styles.accordionSummary}>
                <div
                  className={`display_flex_row ${Styles.accordionSummaryHead}`}
                >
                  <div>Interested Companies Offers</div>
                  {expanded !== "conn" ? <ExpandMore /> : <ExpandLess />}
                </div>
              </AccordionSummary>

              <AccordionDetails>
                <div className={Styles.cont_Details_main}>
                  <div className={`display_flex_row ${Styles.contHeading}`}>
                    <div>Sr. No.</div>
                    <div>Avg Energy Rate (₹/kWh)</div>
                    <div>Avg Quantity (MW)</div>
                  </div>
                  <div className={`scroll_bar_x ${Styles.contDetailsMain}`}>
                    {interestedListingsLoading ? (
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          padding: "16px 0",
                        }}
                      >
                        Loading...
                      </div>
                    ) : (
                      InterestedListings.map((item, idx) => (
                        <div className="display_flex_row" key={item.id || idx}>
                          <div>{idx + 1}</div>
                          <div>{formatToDecimals(item.averageRate, 1)}</div>
                          <div>{formatToDecimals(item.averageQuantity, 1)}</div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        )}
        <div className={`${Styles.buttonContainer}`}>
          {(counterData.status === "ACTIVE" ||
            counterData.status === "WITHDRAWN") && (
            <button
              disabled={loading}
              className={`activeButton_type_2 ${Styles.button_Conn}`}
              onClick={() => setOpenConfirmModal(true)}
            >
              {loading ? "Connecting..." : "Connect"}
            </button>
          )}
        </div>
        <ConfirmationModal
          open={openConfirmModal}
          handleClose={() => setOpenConfirmModal(false)}
          handleSubmit={() => handlePlaceBid()}
          header={"Connection Request Confirmation"}
          data={
            "Sending a connection request will share your masked details with the listing owner. Do you want to continue?"
          }
          loading={loading}
        />
      </div>
    </Modal>
  );
};

export default PlaceBid;
